module.exports = __webpack_public_path__ + "static/media/ic-standarisasi.89adb7ca.webp";